module.exports = "@import url(\"https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap\");\n.doughnut-chart {\n  width: 100%;\n  height: 90%; }\n"